import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import Logo from '../../img/fpg_logo.png'; // Make sure this path is right!

// --- STYLES ---
const styles = {
  navBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '80px',
    backgroundColor: '#0b132b', // DEEP NAVY: Matches your App.js background perfectly
    borderBottom: '1px solid #1c2b4d', // Dark blue border instead of light grey
    padding: '0 40px',
    color: '#f8fafc', // Light text
    position: 'relative',
    zIndex: 1000,
    boxShadow: '0 4px 20px rgba(0,0,0,0.4)', // Darker shadow for depth
  },
  navGroup: {
    display: 'flex',
    gap: '30px', 
    alignItems: 'center',
  },
  linkText: {
    textDecoration: 'none',
    color: '#cbd5e1', // Slate grey/blue for inactive links
    fontSize: '16px', 
    fontWeight: '600', 
    transition: 'color 0.2s',
    textTransform: 'uppercase', 
    letterSpacing: '1px',
  },
  activeLink: {
    color: '#b026ff', // Keep the Purple Accent!
    fontWeight: 'bold',
  },
  // Dropdown Styles
  dropdownContainer: {
    position: 'relative',
    cursor: 'pointer',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', 
    left: '-10px',
    backgroundColor: '#111c3a', // Lighter navy for the dropdown box
    minWidth: '160px',
    boxShadow: '0px 10px 25px rgba(0,0,0,0.6)',
    borderRadius: '4px',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #2a3b61', // Subtle blue border
  },
  dropdownItem: {
    padding: '10px 20px',
    textDecoration: 'none',
    color: '#e2e8f0', // Off-white text
    display: 'block',
    fontSize: '16px',
    transition: 'background-color 0.2s, color 0.2s',
  }
};

export default function PageHeader() {
  const location = useLocation(); // Get current URL path
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // Helper to check active state
  const isActive = (path) => location.pathname === path;

  return (
    <div style={styles.navBar}>
      {/* LOGO AREA */}
      <Link to="/home">
        <img src={Logo} style={{ height: '50px', width: 'auto' }} alt="Foreplay Games" />
      </Link>

      {/* NAVIGATION AREA */}
      <div style={styles.navGroup}>
        
        {/* HOME LINK */}
        <Link 
          to="/home" 
          style={{ 
            ...styles.linkText, 
            ...(isActive('/home') ? styles.activeLink : {}) 
          }}
        >
          Home
        </Link>

        {/* GAMES DROPDOWN */}
        <div 
          style={styles.dropdownContainer}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <span style={{ 
            ...styles.linkText, 
            ...(location.pathname.includes('/games') ? styles.activeLink : {}) 
          }}>
            Games ▾
          </span>

          {isDropdownOpen && (
            <div style={styles.dropdownMenu}>
              <Link 
                to="/games/3xr" 
                style={styles.dropdownItem}
                className="dropdown-hover" // You can add CSS hover effects in App.css for this
              >
                3XRay
              </Link>
              <Link to="/games/lonelyhands" style={styles.dropdownItem} className="dropdown-hover">
                LonelyHands
              </Link>
              {/* Add Forest Folly later */}
            </div>
          )}
        </div>

        {/* NEW: DEVLOG */}
        <Link 
          to="/devlog" 
          style={{ ...styles.linkText, ...(isActive('/devlog') ? styles.activeLink : {}) }}
        >
          Devlog
        </Link>

        <Link 
          to="/jobs" 
          style={{ ...styles.linkText, ...(isActive('/jobs') ? styles.activeLink : {}) }}
        >
          Jobs
        </Link>

        {/* NEW: FAQ */}
        <Link 
          to="/faq" 
          style={{ ...styles.linkText, ...(isActive('/faq') ? styles.activeLink : {}) }}
        >
          FAQ
        </Link>

        <Link 
          to="/ai-policy" 
          style={{ ...styles.linkText, ...(isActive('/ai-policy') ? styles.activeLink : {}) }}
        >
          AI Policy
        </Link>

      </div>
    </div>
  );
}